import React from "react";
import { LineGraphProvider } from "../../Context/lineGraphContext";
import LineGraphComp from "../CardsComponents/LineGraphComp";
import { Window, WindowTitle } from "./styles";
import { Container, Row, Col } from "react-bootstrap";

function CustomerServiceWindow({ range }) {
  const endDate = range ? range.end : new Date();
  const startDate = range ? range.start : new Date(new Date().setDate(endDate.getDate() - 7));

  const orderEntryEndDate = range ? range.end : new Date();
  const orderEntryStartDate = range ? range.start : new Date(new Date().setDate(orderEntryEndDate.getDate() - 6));

  const tatEndDate = range ? range.end : new Date();
  const tatStartDate = range ? range.start : new Date(new Date().setDate(tatEndDate.getDate() - 364));

  const hourlyQuery = range ? "" : "?last=24";

  return (
    <Container fluid style={{ marginBottom: 50 + "px" }}>
      <Row className="justify-content-center">
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Orders TAT Graph</WindowTitle>
            <LineGraphProvider
              url="GetOrderTatValues"
              startDate={tatStartDate}
              endDate={tatEndDate}
            >
              <LineGraphComp
                height={"280px"}
                colors={["#3347E6", "#EF1D1D"]}
              />
            </LineGraphProvider>
          </Window>
        </Col>
      </Row>
      <Row>
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Hourly Unread Emails Count</WindowTitle>
            <LineGraphProvider
              controller="CustomerService"
              url="GetUnreadEmailStatsValues"
              startDate={startDate}
              endDate={endDate}
              refreshInterval={0}
              query={hourlyQuery}
            >
              <LineGraphComp height={"280px"} showFullDate={true} dateFormat="MM/DD HH:mm" colors={["#EF1D1D"]} />
            </LineGraphProvider>
          </Window>
        </Col>
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Daily Unread Emails Count</WindowTitle>
            <LineGraphProvider
              controller="CustomerService"
              url="GetUnreadEmailDailyStatsValues"
              startDate={orderEntryStartDate}
              endDate={orderEntryEndDate}
              refreshInterval={0}
            >
              <LineGraphComp height={"280px"} showFullDate={true} dateFormat="MM/DD" colors={["#EF1D1D"]} />
            </LineGraphProvider>
          </Window>
        </Col>
      </Row>
      <Row>
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Hourly Read Emails Count</WindowTitle>
            <LineGraphProvider
              controller="CustomerService"
              url="GetEmailStatsValues"
              startDate={startDate}
              endDate={endDate}
              refreshInterval={0}
              query={hourlyQuery}
            >
              <LineGraphComp height={"280px"} showFullDate={true} dateFormat="MM/DD HH:mm" />
            </LineGraphProvider>
          </Window>
        </Col>
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Daily Read Emails Count</WindowTitle>
            <LineGraphProvider
              controller="CustomerService"
              url="GetEmailDailyStatsValues"
              startDate={orderEntryStartDate}
              endDate={orderEntryEndDate}
              refreshInterval={0}
            >
              <LineGraphComp height={"280px"} showFullDate={true} dateFormat="MM/DD" />
            </LineGraphProvider>
          </Window>
        </Col>
      </Row>
      <Row>
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Hourly Orders Entered Report</WindowTitle>
            <LineGraphProvider
              controller="CustomerService"
              url="GetOrderEntryHourlyValues"
              startDate={startDate}
              endDate={endDate}
              refreshInterval={0}
            >
              <LineGraphComp
                height={"280px"}
                showFullDate={true}
                dateFormat="MM/DD HH:mm"
                colors={["#3347E6", "#EF5DA8", "#2ECC71", "#F5A623"]}
                sortTooltip={true}
              />
            </LineGraphProvider>
          </Window>
        </Col>
        <Col lg={6} md={12}>
          <Window style={{ display: "block", height: "420px" }}>
            <WindowTitle>Daily Orders Entered Report</WindowTitle>
            <LineGraphProvider
              controller="CustomerService"
              url="GetOrderEntryValues"
              startDate={orderEntryStartDate}
              endDate={orderEntryEndDate}
              refreshInterval={0}
            >
              <LineGraphComp
                height={"280px"}
                showFullDate={true}
                dateFormat="MM/DD"
                colors={["#3347E6", "#EF5DA8", "#2ECC71", "#F5A623"]}
                sortTooltip={true}
              />
            </LineGraphProvider>
          </Window>
        </Col>
      </Row>
    </Container>
  );
}

export default CustomerServiceWindow;
